$(document).ready(function(){
    $(document).on('change', '.quantity_selector--wrapper .customize_wrapper:not(.hidden) .quantity__input', function(){
        const __this = $(this);
        const productQty = parseInt($(this).val(), 10) || 0;
        show_discount(__this, productQty);
    });

    $(document).on('click', '.quantity_selector--wrapper .quantity-tab li', function(){
        const __this = $(this);
        const productQty = parseInt(__this.closest('.quantity_selector--wrapper .customize_wrapper:not(.hidden)').find('.quantity__input').val(), 10) || 0;
        show_discount(__this, productQty);
    });

    $(document).on('change', '.quantity_selector--wrapper .patches-block-info:not(.hidden) .quantity__input', function(){
        const __this = $(this);
        const productQty = parseInt($(this).val(), 10) || 0;
        patch_show_discount(__this, productQty);
    }); 

    $(document).on('click', '.quantity_selector--wrapper .patches-block-info:not(.hidden) .quantity-tab li', function(){
        const __this = $(this);
        const productQty = parseInt(__this.closest('.quantity_selector--wrapper').find('.quantity__input').val(), 10) || 0;
        patch_show_discount(__this, productQty);
    });

    // Helper to format product label (singular/plural)
    function getProductLabel(productType, remainQty) {
        const typeStr = productType || '';
        if (typeStr.toLowerCase() === 'hats') {
            return remainQty === 1 ? window.customTranslations.hat : window.customTranslations.hats;
        } else if (typeStr.toLowerCase() === 'items') {
            return remainQty === 1 ? window.customTranslations.item : window.customTranslations.items;
        }
        return typeStr;
    }

    // Helper to update HTML content
    function updateDiscountUI(selectors, discountText, setupFeeText) {
        $(selectors.text).html(discountText);
        $(selectors.setupFee).html(setupFeeText);
    }

    // Process tiers
    function getDiscountDetails(productQty, productType, isBlank) {
        const tiers = isBlank 
            ? [
                { limit: 6, discount: '5%' },
                { limit: 12, discount: '15%' },
                { limit: 25, discount: '17%' },
                { limit: 50, discount: '20%' },
                { limit: 100, discount: '23%' },
                { limit: 250, discount: '25%' }
              ]
            : [
                { limit: 6, discount: '10%', setupLimit: 12 },
                { limit: 12, discount: '30%', setupLimit: 12 },
                { limit: 25, discount: '35%', setupFree: true },
                { limit: 50, discount: '40%', setupFree: true },
                { limit: 100, discount: '45%', setupFree: true },
                { limit: 250, discount: '50%', setupFree: true }
              ];

        const maxDiscount = isBlank ? '25%' : '50%';
        
        for (const tier of tiers) {
            if (productQty < tier.limit) {
                const remainQty = tier.limit - productQty;
                const productLabel = getProductLabel(productType, remainQty);
                const discountText = window.customTranslations.order_more_save
                                        .replace('{{ remainQty }}', remainQty)
                                        .replace('{{ productLabel }}', productLabel)
                                        .replace('{{ discount }}', tier.discount);
                
                let setupFeeText = '';
                if (!isBlank) {
                    if (tier.setupFree) {
                        setupFeeText = window.customTranslations.eligible_free_setup;
                    } else if (tier.setupLimit) {
                        const remainQtyCustom = tier.setupLimit - productQty;
                        const customProductLabel = getProductLabel(productType, remainQtyCustom);
                        setupFeeText = window.customTranslations.order_more_free_setup
                                        .replace('{{ remainQtyCustom }}', remainQtyCustom)
                                        .replace('{{ customProductLabel }}', customProductLabel);
                    }
                }
                
                return { discountText, setupFeeText };
            }
        }

        // Default / Max Tier (productQty >= 250)
        return {
            discountText: window.customTranslations.saving_max.replace('{{ maxDiscount }}', maxDiscount),
            setupFeeText: isBlank ? '' : window.customTranslations.eligible_free_setup
        };
    }

    function show_discount(__this, productQty) {
        const productType = $('.quantity_selector-discount-wrapper').attr('data-product-type') || '';
        const isBlank = __this.closest('.quantity_selector--wrapper').find('.product-form-btn').hasClass('purchase-blank');
        const selectors = {
            text: '.product-discount-text',
            setupFee: '.product-discount-setup-fee'
        };

        const { discountText, setupFeeText } = getDiscountDetails(productQty, productType, isBlank);
        updateDiscountUI(selectors, discountText, setupFeeText);
    }

    function patch_show_discount(__this, productQty) {
        const productType = $('.quantity_selector-discount-wrapper').attr('data-product-type') || '';
        const selectors = {
            text: '.patch-product-discount-text',
            setupFee: '.patch-product-discount-setup-fee'
        };

        const { discountText, setupFeeText } = getDiscountDetails(productQty, productType, false);
        updateDiscountUI(selectors, discountText, setupFeeText);
    }
});